import './DataTableSelectionChip.css';
export var selectionChip = '_1rlvxpp4-3-8-0';
export var selectionChipWrapper = {condensed:'_1rlvxpp1-3-8-0 _1rlvxpp0-3-8-0','default':'_1rlvxpp2-3-8-0 _1rlvxpp0-3-8-0',comfortable:'_1rlvxpp3-3-8-0 _1rlvxpp0-3-8-0'};